import { routePaths } from "@/App";
import { TourDetailsSkeleton } from "@/libs/tours/views/TourDetailsSkeleton";
import { lazy, Suspense } from "react";
import { Navigate, useParams } from "react-router-dom";

const TourDetails = lazy(
  () => import("../../libs/tours/views/TourDetailsView"),
);

export function TourDetailsPage() {
  const { id } = useParams<{ id: string }>();

  if (!id || typeof id !== "string") {
    return <Navigate to={routePaths.home} />;
  }

  return (
    <Suspense fallback={<TourDetailsSkeleton />}>
      <TourDetails tourId={id} />
    </Suspense>
  );
}
